import { Theme, createStyles } from '@material-ui/core';
import type { ServiceCardProps } from './ServiceCard';

const styles = (
  theme: Theme,
) => {
  const { colors: { pageElements: { serviceCard } } } = theme;
  return createStyles<string, Partial<ServiceCardProps>>({
    name: {
      color: ({ disabled }) => (disabled ? serviceCard.disabled.name : serviceCard.enabled.name),
      '$root:hover > &': {
        color: ({ disabled }) => (disabled ? serviceCard.disabled.name : serviceCard.hovered.name),
      },
      '$root:active > &': {
        color: ({ disabled }) => (disabled ? serviceCard.disabled.name : serviceCard.pressed.name),
      },
    },
    root: {
      userSelect: 'none',
      cursor: 'pointer',
      padding: ({ variant }) => (variant === 'default'
        ? `${theme.spacing(4)}px ${theme.spacing(3)}px`
        : `${theme.spacing(3)}px ${theme.spacing(3)}px`),
      width: '100%',
      borderRadius: serviceCard.corner,
      backgroundColor: ({ disabled }) => (disabled ? serviceCard.disabled.fill : serviceCard.enabled.fill),
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      borderBottom: `2px solid ${serviceCard.enabled.stroke}`,
      '&:hover': {
        backgroundColor: ({ disabled }) => (disabled ? serviceCard.disabled.fill : serviceCard.hovered.fill),
        borderBottom: `2px solid ${serviceCard.enabled.stroke}`,
      },
      '&:active': {
        backgroundColor: ({ disabled }) => (disabled ? serviceCard.disabled.fill : serviceCard.pressed.fill),
      },
    },
    icon: {
      display: theme.flags.showIcons ? 'inline-flex' : 'none',
      borderRadius: '100%',
      width: `${theme.spacing(8)}px`,
      minWidth: `${theme.spacing(8)}px`,
      height: `${theme.spacing(8)}px`,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: serviceCard.enabled.emblemBackground,
      margin: `-${theme.spacing(2)}px`,
      marginRight: `${theme.spacing(1)}px`,
    },
    endIcon: {
      display: theme.flags.showIcons ? 'none' : 'unset',
      color: ({ disabled }) => (disabled ? serviceCard.disabled.proceedIcon : serviceCard.enabled.proceedIcon),
      float: 'right',
      marginLeft: 'auto',
      '$root:hover > &': {
        color: ({ disabled }) => (disabled ? serviceCard.disabled.proceedIcon : serviceCard.hovered.proceedIcon),
      },
      '$root:active > &': {
        color: ({ disabled }) => (disabled ? serviceCard.disabled.proceedIcon : serviceCard.pressed.proceedIcon),
      },
    },
    actions: {
      float: 'right',
      marginLeft: 'auto',

      '& path': {
        fill: ({ disabled }: { disabled: boolean }) => (
          disabled ? serviceCard.disabled.proceedIcon : serviceCard.enabled.proceedIcon
        ),
      },
      '$root:hover > & path': {
        fill: ({ disabled }: { disabled: boolean }) => (
          disabled ? serviceCard.disabled.proceedIcon : serviceCard.hovered.proceedIcon
        ),
      },
      '$root:active > & path': {
        fill: ({ disabled }: { disabled: boolean }) => (
          disabled ? serviceCard.disabled.proceedIcon : serviceCard.pressed.proceedIcon
        ),
      },
    },
  });
};
export default styles;
